export default "__VITE_ASSET__cW5uRrZ5__"